import {StyleSheet} from 'react-native';
import {Colors} from '../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 500,
    alignSelf: 'center',
    height: 500,
    backgroundColor: 'white',
    borderRadius: 8,
    paddingHorizontal: 30,
    paddingVertical: 30,
  },
  imageBackground: {flex: 1, justifyContent: 'center',backgroundColor: '#e61c2b'},
  simbol: {alignSelf: 'center', marginBottom: 70},
  title: {
    fontSize: 22,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 26,
    textAlign: 'center',
    color: 'black',
    maxWidth: 200,
    alignSelf: 'center',
  },
  description: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: 'gray',
    textAlign: 'center',
    maxWidth: 250,
    alignSelf: 'center',
    marginTop: 20,
  },
  goBack: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    textAlign: 'center',
    maxWidth: 220,
    alignSelf: 'center',
    marginTop: 20,
    color: Colors.RedPallete.red,
  },
  toast: {
    height: 55,
    width: '97%',
    backgroundColor: Colors.GreenPallete.greenOne,
    position: 'absolute',
    top: 0,
    borderBottomEndRadius: 4,
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 20,
  },
  check: {marginRight: 10},
  toastText: {
    fontSize: 10,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'white',
  },
  horizontalSpace: {
    paddingHorizontal: 15,
  },
});
